/* Header search disclosure; the ordinary search link remains the no-JS fallback. */
(() => {
  'use strict';
  if (window.vnHeaderSearch20261023) {
    window.vnHeaderSearch20261023.start();
    return;
  }
  const controllers = new Map();
  function initialize(header) {
    if (controllers.has(header)) return;
    const toggle = header.querySelector('[data-vn-search-toggle]');
    const panel = header.querySelector('[data-vn-header-search]');
    const input = panel?.querySelector('[data-vn-search-input]');
    if (!toggle || !panel || !input) return;
    const abort = new AbortController();
    const listen = (element, name, handler) => element?.addEventListener(name, handler, { signal: abort.signal });
    toggle.setAttribute('role', 'button');
    const close = (restoreFocus = false) => {
      if (panel.hidden) return;
      panel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Abrir búsqueda');
      if (restoreFocus && toggle.isConnected) toggle.focus({ preventScroll: true });
    };
    const open = () => {
      panel.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', 'Cerrar búsqueda');
      input.focus({ preventScroll: true });
    };
    listen(toggle, 'click', event => {
      event.preventDefault();
      if (panel.hidden) open();
      else close(true);
    });
    listen(toggle, 'keydown', event => {
      if (event.key === ' ') { event.preventDefault(); toggle.click(); }
    });
    listen(panel.querySelector('[data-vn-search-close]'), 'click', () => close(true));
    listen(document, 'keydown', event => {
      if (event.key === 'Escape' && !panel.hidden) {
        event.preventDefault();
        close(true);
      }
    });
    listen(document, 'pointerdown', event => {
      if (!panel.hidden && !panel.contains(event.target) && !toggle.contains(event.target)) close();
    });
    listen(header.querySelector('.vn-cab__nav'), 'pointerenter', () => close());
    listen(header.querySelector('[data-vn-mobile-toggle]'), 'click', () => close());
    listen(document, 'focusin', event => {
      if (!panel.hidden && !panel.contains(event.target) && !toggle.contains(event.target)) close();
    });
    listen(panel.querySelector('form'), 'submit', event => {
      input.value = input.value.trim();
      if (!input.value) { event.preventDefault(); input.focus(); }
    });
    controllers.set(header, { destroy() { close(); abort.abort(); controllers.delete(header); } });
  }
  function start(root = document) {
    if (root instanceof Element && root.matches('[data-vn-cab]')) initialize(root);
    root.querySelectorAll('[data-vn-cab]').forEach(initialize);
  }
  window.vnHeaderSearch20261023 = { start };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(), { once: true });
  else start();
  document.addEventListener('shopify:section:load', event => start(event.target));
  document.addEventListener('shopify:section:unload', event => {
    controllers.forEach((controller, header) => {
      if (header === event.target || event.target.contains(header)) controller.destroy();
    });
  });
  window.addEventListener('pagehide', () => controllers.forEach(controller => controller.destroy()));
  window.addEventListener('pageshow', () => start());
})();
